import { LanguageToggle, useLanguage } from "../i18n/Language";
import React, { useState } from 'react';

const Header = () => {
  const { t } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 reference-header shadow-sm">
      <div className="flex justify-between items-center px-4 md:px-8 lg:px-16 py-4 md:py-5">
        <a href="/" onClick={closeMenu} aria-label={t("Dr. Bharat Reddy Katta — Home")} className="flex items-center gap-3 md:gap-6 min-w-0 no-underline rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary">
          <img
            src="/images/DrBharathReddyKattaOrthoLogo.png"
            alt={t("Dr. Bharat Reddy Katta")} width="544" height="553"
            className="h-12 md:h-16 w-auto flex-shrink-0 object-contain transition-transform duration-300 hover:scale-105" />

          <div className="doctor-info min-w-0">
            <p className="text-blue-900 text-base sm:text-xl md:text-2xl lg:text-3xl font-semibold m-0 leading-tight tracking-tight whitespace-nowrap overflow-hidden text-ellipsis">{t("Dr. Bharat Reddy Katta")}

            </p>
            <p className="text-blue-900/80 text-xs sm:text-sm md:text-base font-medium mt-0.5 md:mt-1 tracking-wide">{t("Knee & Hip Replacement Surgeon")}

            </p>
          </div>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex gap-4 xl:gap-8 items-center">
          <a
            href="/"
            className="text-blue-900 no-underline font-medium text-base transition-all duration-300 whitespace-nowrap relative py-2 hover:text-blue-700 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all after:duration-300 hover:after:w-full">{t("Home")}


          </a>
          <a href="/#about" onClick={closeMenu} className="text-blue-900 no-underline font-medium text-base transition-all duration-300 whitespace-nowrap relative py-2 hover:text-blue-700 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all after:duration-300 hover:after:w-full">{t("About Us")}</a>
          <a
            href="/services/"
            className="text-blue-900 no-underline font-medium text-base transition-all duration-300 whitespace-nowrap relative py-2 hover:text-blue-700 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all after:duration-300 hover:after:w-full">{t("Our Treatments")}


          </a>
          <a
            href="/#contact"
            className="text-blue-900 no-underline font-medium text-base transition-all duration-300 whitespace-nowrap relative py-2 hover:text-blue-700 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all after:duration-300 hover:after:w-full">{t("Contact")}


          </a>
        <LanguageToggle /></nav>

        {/* Mobile Hamburger Icon */}
        <button
          onClick={toggleMenu}
          className="lg:hidden flex flex-col justify-center items-center w-10 h-10 rounded-lg hover:bg-gray-100 transition-colors duration-300 flex-shrink-0"
          aria-label={t("Toggle menu")}
          aria-expanded={isMenuOpen}
          aria-controls="mobile-navigation">

          <span className={`block w-6 h-0.5 bg-blue-900 transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-blue-900 mt-1.5 transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-blue-900 mt-1.5 transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <nav id="mobile-navigation" hidden={!isMenuOpen}
      className={`lg:hidden reference-header border-t border-blue-900/10 overflow-hidden transition-all duration-300 ${
      isMenuOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'}`}>


        <div className="flex flex-col py-2">
          <a
            href="/"
            onClick={closeMenu}
            className="text-blue-900 no-underline font-medium text-base px-6 py-3 hover:bg-gray-50 hover:text-blue-700 transition-all duration-300">{t("Home")}


          </a>
          <a href="/#about" onClick={closeMenu} className="text-blue-900 no-underline font-medium text-base px-6 py-3 hover:bg-gray-50 hover:text-blue-700 transition-all duration-300">{t("About Us")}</a>
          <a
            href="/services/"
            onClick={closeMenu}
            className="text-blue-900 no-underline font-medium text-base px-6 py-3 hover:bg-gray-50 hover:text-blue-700 transition-all duration-300">{t("Our Treatments")}


          </a>
          <a
            href="/#contact"
            onClick={closeMenu}
            className="text-blue-900 no-underline font-medium text-base px-6 py-3 hover:bg-gray-50 hover:text-blue-700 transition-all duration-300">{t("Contact")}


          </a>
        </div>
      </nav>
    </header>);

};

export default Header;
